import { getDB } from './db';
import api from './api';

function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export async function enqueue(
  method: string,
  url: string,
  data?: any,
  headers?: Record<string, string>
): Promise<string> {
  const db = await getDB();
  const id = generateId();
  await db.put('sync_queue', {
    id,
    method,
    url,
    data,
    headers,
    retries: 0,
    max_retries: 5,
    created_at: new Date().toISOString(),
  });
  return id;
}

export async function getPendingCount(): Promise<number> {
  const db = await getDB();
  return db.count('sync_queue');
}

export async function processQueue(): Promise<{ success: number; failed: number }> {
  const db = await getDB();
  const items = await db.getAll('sync_queue');
  let success = 0;
  let failed = 0;

  for (const item of items) {
    try {
      await api.request({
        method: item.method,
        url: item.url,
        data: item.data,
        headers: item.headers,
      });
      await db.delete('sync_queue', item.id);
      success++;
    } catch (error: any) {
      // Don't retry 4xx errors (client errors)
      if (error.response && error.response.status >= 400 && error.response.status < 500) {
        await db.delete('sync_queue', item.id);
        failed++;
        continue;
      }

      // Increment retry counter
      item.retries++;
      if (item.retries >= item.max_retries) {
        await db.delete('sync_queue', item.id);
        failed++;
      } else {
        await db.put('sync_queue', item);
        failed++;
      }
    }
  }

  return { success, failed };
}

export async function clearQueue(): Promise<void> {
  const db = await getDB();
  await db.clear('sync_queue');
}
